
import { useState } from 'react';
import { Client } from '@/components/clients/types';
import { EnrichmentResponse } from '@/hooks/useCompanyEnrichment';

export interface EnrichmentDialogDataType {
  client: Client;
  result: EnrichmentResponse | null; // This matches the structure used in the original hook
}

export const useEnrichmentDialogManager = () => {
  const [isEnrichmentDialogOpen, setIsEnrichmentDialogOpen] = useState(false);
  const [enrichmentDialogData, setEnrichmentDialogData] = useState<EnrichmentDialogDataType | null>(null);

  const openEnrichmentDialog = (data: EnrichmentDialogDataType) => {
    setEnrichmentDialogData(data);
    setIsEnrichmentDialogOpen(true);
  };

  const closeEnrichmentDialog = () => {
    setIsEnrichmentDialogOpen(false);
    setEnrichmentDialogData(null);
  };

  return {
    isEnrichmentDialogOpen,
    enrichmentDialogData,
    openEnrichmentDialog,
    closeEnrichmentDialog,
  };
};
